import { render, staticRenderFns } from "./view-file-info.vue?vue&type=template&id=630e989f&scoped=true"
import script from "./view-file-info.vue?vue&type=script&lang=ts"
export * from "./view-file-info.vue?vue&type=script&lang=ts"
import style0 from "./view-file-info.vue?vue&type=style&index=0&id=630e989f&prod&lang=less&scoped=true"
import style1 from "./view-file-info.vue?vue&type=style&index=1&id=630e989f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630e989f",
  null
  
)

export default component.exports